import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "./icons";
import { Col, Container, Row } from "react-bootstrap";

const Social = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  var res = Object.entries(props);
  console.log("res", res);
  return (
    <>
      <Container style={{ display: "flex" }}>
        <Row xs={12} sm={4}>
          {res.map((value, index) => {
            const { network, url } = value[1];
            return (
              <>
                <Col>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`link to ${network} profile`}
                  >
                    <FontAwesomeIcon
                      style={{ fontSize: "50px" }}
                      size={"lg"}
                      icon={icons[network]}
                    />
                  </a>
                </Col>
              </>
            );
          })}
        </Row>
      </Container>
      {/* <Form isVisible={isVisible} /> */}
    </>
  );
};

export default Social;
